import * as actionTypes from "./actionTypes";
import { firebase } from "../../firebase/index";
import { collections } from "../../firebase/firestoreNameSpaces";

// import { token } from "../../data";
const authSuccess = (userId, payload) => {
  return {
    type: actionTypes.AUTH_SUCCESS,
    payload: { userId, ...payload },
  };
};

export const logout = () => {
  firebase
    .auth()
    .signOut()
    .then(
      function () {
        localStorage.removeItem("idToken");
        localStorage.removeItem("auth");
        localStorage.removeItem("credential");
        localStorage.removeItem("userId");

        // window.location.reload()
      },
      function (error) {
        console.error("Sign Out Error", error);
      }
    );
  // localStorage.removeItem("idToken");

  return {
    type: actionTypes.AUTH_LOGOUT,
  };
};

export const checkAuthState = () => {
  return (dispatch) => {
    firebase.auth().onAuthStateChanged(function (user) {
      // console.clear()
      // console.log("on STate changed")
      if (user) {
        //  let token =" "

        let userId = user.uid;

        // const userId = localStorage.getItem("userId");

        dispatch({
          type: actionTypes.SET_CART_ORDER,
          payload: { userId: userId },
        });

        if (!userId) {
          dispatch(logout());
        } else {
          let token = localStorage.getItem("idToken");
          let auth = localStorage.getItem("auth");
          let minifiedUser = {
            user: {
              userId: user.uid,
              phoneNumber: user.phoneNumber,
            },
          };
          if (auth == "uans" && token) {
            minifiedUser["idToken"] = token;
            minifiedUser["admin"] = true;
            dispatch(authSuccess(user.uid, minifiedUser));
          } else if (auth == "usna") {
            minifiedUser["idToken"] = token;
            minifiedUser["staff"] = true;
            dispatch(authSuccess(user.uid, minifiedUser));
          } else {
            minifiedUser["idToken"] = null;
            minifiedUser["admin"] = false;
            minifiedUser["staff"] = false;
            dispatch(setUser(userId, minifiedUser));
          }

          // console.clear()
          //This function is called for getting users Interests. But it can be avoided and can only be run on
          //when user requests the interests by clicking on profile.
          //Other thing detach listeners when not needed
        }
      } else {
        dispatch(logout());
      }
    });
  };
};

export const auth = () => {
  return (dispatch) => {
    let provider = new firebase.auth.GoogleAuthProvider();
    provider.setCustomParameters({
      display: "popup",
      login_hint: "user@example.com",
      prompt: "select_account",
    });

    // // provider.addScope("user_birthday");
    // provider.setCustomParameters({
    //   display: "popup",
    // });

    firebase
      .auth()
      .signInWithPopup(provider)
      .then(function (result) {
        // This gives you a Facebook Access Token. You can use it to access the Facebook API.

        localStorage.setItem("credential", JSON.stringify(result.credential));

        var token = result.credential.idToken;
        // The signed-in user info.
        var user = result.user;
        let minifiedUser = {
          phoneNumber: user.phoneNumber,
          userId: user.uid,
          email: user.email,
        };

        // console.log(firebase.auth().currentUser.uid)

        let db = firebase.firestore();
        db.collection(collections.STAFFS)
          .doc(user.uid)
          .get()
          .then((snapshot) => {
            // console.log(snapshot.data())
            if (snapshot.exists) {
              //Staff
              let data = snapshot.data();
              if (data.admin) {
                localStorage.setItem("idToken", token);
                localStorage.setItem("auth", "uans");

                dispatch({
                  type: actionTypes.AUTH_SUCCESS,
                  payload: {
                    userId: user.uid,
                    idToken: token,
                    user: minifiedUser,
                    admin: true,
                  },
                });
              } else if (data.staff) {
                localStorage.setItem("idToken", token);
                localStorage.setItem("auth", "usna");

                dispatch({
                  type: actionTypes.AUTH_SUCCESS,
                  payload: {
                    userId: user.uid,
                    idToken: token,
                    user: minifiedUser,
                    staff: true,
                  },
                });
              } else {
                alert(
                  "Sorry You have not assigned any role or you might be deactivated by the admin"
                );
                logout();
              }
            } else {
              //Not A Staff
              alert("Sorry You are not our staff");
              logout();
            }
          })
          .catch((err) => {
            return alert(err);
          });
        // dispatch(authSuccess(user.uid, minifiedUser));
      })
      .catch(function (error) {
        logout();
        return alert(error);

        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        // The email of the user's account used.
        var email = error.email;
        // The firebase.auth.AuthCredential type that was used.
        var credential = error.credential;
        // ...
      });
  };
};

export const signInStaff = (dispatch) => {
  return new Promise((resolve, reject) => {
    let provider = new firebase.auth.GoogleAuthProvider();
    // provider.setCustomParameters({
    //   login_hint: "user@example.com",
    // });

    // provider.addScope("user_birthday");
    provider.setCustomParameters({
      display: "popup",
      login_hint: "user@example.com",
      prompt: "select_account",
    });

    firebase
      .auth()
      .signInWithPopup(provider)
      .then(function (result) {
        return resolve(result.user.uid);
      })
      .catch((err) => {
        // window.location.reload()
        dispatch({
          type: actionTypes.UTILITY_CONTROLS,
          payload: { addStaffLoading: false },
        });
        return alert(err);
      });
  });
};

export const sigInWithCustomToken = (credential) => {
  return new Promise((resolve, reject) => {
    firebase
      .auth()
      .signInWithCredential(credential)
      .then((result) => {
        return resolve(true);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};
export const setUser = (userId, minifiedUser) => {
  return async (dispatch) => {
    try {
      let db = firebase.firestore();
      let data = (
        await db.collection(collections.USERS).doc(userId).get()
      ).data();
      if (data) {
        if (!data.addresses) {
          data.addresses = {};
        }

        dispatch({
          type: actionTypes.SET_USER,
          payload: { user: data, userId },
        });
      }

      //   db.collection(collections.USERS).doc(userId)
      //   .onSnapshot(snapshot=>{
      //     let data = snapshot.data();
      //     console.log(data)
      //     if(data){

      //       if(!data.addresses){
      //         data.addresses = {}
      //           }

      //       dispatch({type:actionTypes.SET_USER,payload:{user:data,userId}})

      // }

      //   })
    } catch (error) {
      alert(error);
      dispatch(authSuccess(userId, minifiedUser));
    }
  };
};
